import UserAvatar, { UserAvatarProps } from '_common/components/UserAvatar/UserAvatar';
import UserColors from 'Editor/services/UserColors/UserColors';

type SuiteAvatarProps = UserAvatarProps & { name?: string };

const SuiteAvatar = ({
  name,
  userId,
  showTooltip,
  online,
  size = 'm',
  margin,
}: SuiteAvatarProps) => {
  let color;
  if (userId === 'IMPORTED_USER') {
    color = UserColors.getUserColor(name || userId)?.name;
  } else if (userId || name) {
    color = UserColors.getUserColor(userId ?? name)?.name;
  }

  return (
    <UserAvatar
      margin={margin}
      size={size}
      userId={userId}
      showTooltip={showTooltip}
      online={online}
      color={color}
    />
  );
};

export default SuiteAvatar;
